
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { listClient, listType, listFrente,listHeadquarter} from 'src/app/web/interfaces/project/project-create/step1';
import Swal from 'sweetalert2';
import { ApiServiceProject } from '../../../../../apis/ApiServiceProject';

interface Permiso {
  exp: number;
  iat: number;
  id: number;
  id_user_erp: number;
  permisses: [];
  role_id: string;
  username: string;
}


@Component({
  selector: 'project-step-1',
  templateUrl: './step1-project.component.html',
  styleUrls: ['./../../create-project.component.scss']
})

export class ProjectStep1Component implements  OnInit  {
  idProject
  clienteindex
  listType: listType[] = []
  listClient: listClient[] = []
  listFrente : listFrente[] = []
  listHeadquarter : listHeadquarter[] = []
  listStage
  listPais
  Step1form: FormGroup;
  listmonedas = []
  permise = false;
  type_select = "";
  public token = "";
  public listPermis: Permiso;
  public permisos_menu: number[] = []
  
  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiServiceProject,
    private errorService:ErrorService

  ) { 
   this.route.params.subscribe((params) => {
      this.idProject = params['id'];
    });
  }

  ngOnInit(): void {
    this.spinner.show()

    this.Step1form = new FormGroup({
    name:new FormControl(''),
    project_alias:new FormControl(''),
    project_type:new FormControl(''),
    customers_id:new FormControl(''),
    fronts_id:new FormControl(''),
    headquarters_id:new FormControl(''),
    technologies:new FormControl(''),
    estimated_cu:new FormControl(''), 
    hh:new FormControl(''),   
    description:new FormControl(''),
    types_payment_id:new FormControl(''),
    commercial_origin:new FormControl(''),
    operation:new FormControl(''),
    });

    // this.token = localStorage.getItem('token')
    // this.listPermis = jwt_decode( this.token);

    // this.listPermis.permisses.map((dato) => {

    //   if (dato > 0) {

    //     if ( this.permisos_menu.find(element => element == dato)) {

    //     } else {
    //       this.permisos_menu.push(Number(dato))
    //     }
    //   }

    // });
    // if(this.idProject != 'null'){
    //   if (this.permisos_menu.find(element => element == 51)) {
    //      this.permise = true;
    //   }
    // }else{
    //   this.permise = true;
    // }


    this.apiService.getService(`list-option-create-project-datos`).subscribe({
      next: (data) => {
        if (data) {
          this.listType = data['listType'];
          this.listClient = data['listClient'];
          this.listStage = data['listStage'];
          this.listPais = data['listPais'];

          //this.concat(null)
          this.dataInfo();
        } else {
          this.spinner.hide()
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })
    
  }

  dataInfo(){
    if (this.idProject != 'null'){
      this.apiService
        .getService('info-project-datos-step-one?id=' + this.idProject)
        .subscribe({
          next: (rs: any) => {
            if (rs) {
              this.Step1form.patchValue(rs);
          
              this.spinner.hide();
              
              // if(this.Step1form.get('play_option_id').value != ""){
              //   if(this.Step1form.get('monto_init').value !=  null && this.Step1form.get('monto_init').value != ""){
              //     this.transformAmountEnd(this.Step1form.get('monto_init').value);
              //   }
              // }
         
              // this.serviTypePa();

              this.concat(rs.customers_id)

            } else {
              this.spinner.hide();
              Swal.fire({
              title:  rs.error,
              text: '',
              icon: 'error',
              heightAuto: false
              });
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        }) 
    }else{
      this.spinner.hide();
    }
  }

  // serviTypePa(){
  //   this.apiService.getService(`list-project-play-option?id_project=${0}`).subscribe({
  //     next: (data) => {
  //       if (data) {
  //         this.listmonedas = data['listPlayOption'];
         
  //         if(this.Step1form.get('play_option_id').value != null && this.Step1form.get('play_option_id').value != '0' && this.Step1form.get('play_option_id').value != ''){
  //           let info = this.listmonedas.filter( n =>  n.id ==  (this.Step1form.get('play_option_id').value))
  //           this.type_select = info[0].name;
  //         }

  //         this.spinner.hide();
  //       } else {
  //         this.spinner.hide()
  //         Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
  //       }
  //     },
  //     error: (error) => {
  //       this.errorService.error(error);
  //     }
  //   })

  // }

  concat(customers_id){
    
    if(customers_id >= 1){
     let frente =  this.listClient.filter( n =>  n.id == customers_id);
     
     if( frente[0].listFrente != null){ 
      this.listFrente = frente[0].listFrente;
      this.listHeadquarter = frente[0].listHeadquarter;
     }
    }
  }

  index(e){
    this.clienteindex = this.Step1form.value.customers_id;
    this.Step1form.value.fronts_id = ['']
    this.listClient.map((dato)=>{
      if(dato.id == this.clienteindex){
      this.listFrente = dato.listFrente
      this.listHeadquarter = [];
      this.Step1form.value.headquarters_id = ['']
      }
    })
  }

  indexEnd(e){
    this.clienteindex = this.Step1form.value.customers_id;
    this.listClient.map((dato)=>{
      if(dato.id == this.clienteindex){
      this.listHeadquarter = dato.listHeadquarter
    }
   })
  }

  formSubmit(){
    var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
    if (form.checkValidity() === false) {
        form.classList.add('was-validated');
    }else{
      this.spinner.show();
      if ( !(Number(this.Step1form.value.estimated_cu) > -1 )) {
        this.spinner.hide();
        Swal.fire({title:'Debe ingresar un numero de casos valido.' ,text: '',icon: 'error',heightAuto: false});
        return;
      }
      if ( !(Number(this.Step1form.value.hh) > -1 )) {
        this.spinner.hide();
        Swal.fire({title:'Debe ingresar un numero de horas estimadas validas.' ,text: '',icon: 'error',heightAuto: false});
        return;
      }


      if(this.idProject == 'null'){
      let post = {
        name: this.Step1form.value.name,
        project_alias:this.Step1form.value.project_alias,
        project_type:Number(this.Step1form.value.project_type),
        customers_id:this.Step1form.value.project_type,
        fronts_id:Number(this.Step1form.value.fronts_id),
        headquarters_id:Number(this.Step1form.value.headquarters_id),
        technologies:this.Step1form.value.technologies,
        estimated_cu:Number(this.Step1form.value.estimated_cu),   
        hh:this.Step1form.value.hh,      
        description: this.Step1form.value.description,
        play_option_id : Number(this.Step1form.value.play_option_id),
        commercial_origin: this.Step1form.value.commercial_origin,
        operation: this.Step1form.value.operation,
      }
      this.apiService.postService(`create-project-datos-step-one`,post).subscribe({
        next: (data) => {
          if (data.id.raw.insertId) {
            Swal.fire({title: data.message ,text: '',icon: 'success',heightAuto: false}).then(()=>{
              this.router.navigate(['/pdg/project/create/', data.id.raw.insertId,'1']);
            })

            this.spinner.hide();
          } else {
            this.spinner.hide()
            Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
          }
        },
        error: (error) => {
          this.errorService.error(error);
        }
      })
      }
      else{
        let post = {
        id: Number(this.idProject),
        name: this.Step1form.value.name,
        project_alias:this.Step1form.value.project_alias,
        project_type:Number(this.Step1form.value.project_type),
        customers_id:""+this.Step1form.value.project_type,
        fronts_id:Number(this.Step1form.value.fronts_id),
        headquarters_id:Number(this.Step1form.value.headquarters_id),
        technologies:this.Step1form.value.technologies,
        estimated_cu:Number(this.Step1form.value.estimated_cu),   
        hh:this.Step1form.value.hh,      
        description: this.Step1form.value.description,
        play_option_id : Number(this.Step1form.value.play_option_id),
        commercial_origin: this.Step1form.value.commercial_origin,
        operation: this.Step1form.value.operation,
      }
      this.apiService.putServiceBody(`update-project-datos-step-one`,post).subscribe({
        next: (data) => {
          if (data) {
            Swal.fire({title: data.message ,text: '',icon: 'success',heightAuto: false}).then(()=>{
              location.reload()
            })

            this.spinner.hide();
          } else {
            this.spinner.hide()
            Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
          }
        },
        error: (error) => {
          this.errorService.error(error);
        }
      })
      }
    }
  }

}
